/**
 * Utility function to safely access a value that might be a function
 * Returns the value directly if it's not a function,
 * or calls the function and returns its result if it is a function
 */
export const getValue = (value: string | (() => string) | undefined): string => {
  if (!value) return ''
  return typeof value === 'function' ? value() : value
}
